import { useState } from 'react'
import { LeaderboardTable, MovementDisplay, PersonalPitcherTable } from './Table'
import { framesConfigMap } from './Map'
import { SpeedChart, SpinDirectionChart, MovementChart, ReleaseHeightPointChart, ReleaseHeightPointTrendChart, SpinTrendChart, MovementTrendChart, KZoneChart, FieldChart, PRChart, KZoneChart2 } from './Charts/Chart'
import { ReactComponent as StrikeS } from '../style/images/eachhitter_icon2.svg'
import { ReactComponent as StrikeC } from '../style/images/eachhitter_icon1.svg'
import { ReactComponent as Foul } from '../style/images/eachhitter_icon3.svg'
import { ReactComponent as InPlay } from '../style/images/eachhitter_icon4.svg'
import { PersonalBatterTable } from './BatterFrame'
import { extractPlateLocationData } from '../Utils/DataProcess'

const displayTab = (type, current, setCurrent) => {
  let tabs = []
  for (const e in framesConfigMap[type]) {
    let tab_classname = e === current ? 'tabr' : 'tab'
    let arrow_classname = e === current ? 'tab_arrowr' : 'tab_arrow'
    tabs.push(
      <div className='tab_block' id={e} onClick={(e) => { setCurrent(e.target.id) }}>
        <div className={tab_classname} id={e}>{framesConfigMap[type][e]}</div>
        <div className={arrow_classname} />
      </div>
    )
  }
  return tabs
}

export const LeaderBoardTableFrame = ({type, data}) => {
  const [current, setCurrent] = useState('tradstat')
  const [movementType, setMovementType] = useState('Pitch')

  //console.log(data)
  const typeGet = (cur) => {
    if (cur === 'tradstat') {
      if (type === 'batter') return 'BtradStat'
      return 'PtradStat'
    }
    if (cur === 'teststat') return 'batter'
    else if (cur === 'teststatPR' || cur === 'teststatPR_Comp') return 'batterPR'
    return 'pitcher'
  }

  const displayTable = (tab) => {
    if (tab === 'movement') {
      return <MovementDisplay data={data[tab]} pitchType={movementType} setPitchType={setMovementType} />
    } else {
      return <LeaderboardTable type={typeGet(current)} id={current} data={data[tab]} />
    }
  }

  return (
    <div className='wrap setin'>
      <div className='page_tab_frame'>
        {displayTab(type, current, setCurrent)}
      </div>
      <div className='page'>
        <div className='page_content'>
          {displayTable(current)}
        </div>
      </div>
    </div>
  )
}

const GraphFrame = ({title, classname, children}) => {
  return (
    <div className='col3'>
      <div className='page_tab_frame2'>
        <div className='tab_block tab_selected'>
          <div className='tab'>{title}</div>
        </div>
      </div>
      <div className='tab_content'>
        <div className={classname}>
          {children}
        </div>
      </div>
    </div>
  )
}

const PitcherGraphPageFrame = ({data, graphData, global, prdata, plateLocData}) => {
  return (
    <div className="page_content tab_table">
      {data === undefined ? [] : <PersonalPitcherTable data={data} />}
      <GraphFrame title='球速分佈' classname='chart_density'>
        {graphData === undefined ? [] : <SpeedChart chartdata={{ personal: graphData.speed, global: global }} />}
      </GraphFrame>
      <GraphFrame title='球種轉軸' classname='chart_windrose'>
        {graphData === undefined ? [] : <SpinDirectionChart chartdata={graphData.sDirection} />}
      </GraphFrame>
      <GraphFrame title='球種位移' classname='chart_windrose'>
        {graphData === undefined ? [] : <MovementChart chartdata={graphData.movement.coordinate} />}
      </GraphFrame>
      <GraphFrame title='指標數據PR' classname='chart_pr'>
        {prdata === undefined ? [] : <PRChart chartdata={prdata} />}
      </GraphFrame>
      <GraphFrame title='進壘位置' classname='chart_spinrate' >
        {plateLocData === {} ? [] : <KZoneChart2 chartdata={plateLocData} />}
      </GraphFrame>
      {/*<GraphFrame title='出手點趨勢' classname='chart_spinrate'>
        {graphData === undefined ? [] : <ReleaseHeightPointTrendChart chartdata={graphData.release.trend} />}
      </GraphFrame>*/}
      <GraphFrame title='球種出手點' classname='chart_spinrate'>
        {graphData === undefined ? [] : <ReleaseHeightPointChart chartdata={graphData.release.coordinate} />}
      </GraphFrame>
      <GraphFrame title='轉速趨勢' classname='chart_spindirection_trend'>
        {graphData === undefined ? [] : <SpinTrendChart chartdata={graphData.spin} />}
      </GraphFrame>
      <GraphFrame title='水平位移趨勢' classname='chart_h_movement_trend'>
        {graphData === undefined ? [] : <MovementTrendChart chartdata={graphData.movement.h} />}
      </GraphFrame>
      <GraphFrame title='垂直位移趨勢' classname='chart_v_movement_trend'>
        {graphData === undefined ? [] : <MovementTrendChart chartdata={graphData.movement.v} />}
      </GraphFrame>
    </div>
  )
}

const pitchCallImageMap = {
  'F': <Foul />,
  'C': <StrikeC />,
  'S': <StrikeS />,
  'I': <InPlay />
}
const PlayByPitchTable = ({data}) => {
  const displayHeader = (num) => {
    let hds = []
    for (let i=0; i<num; i++) {
      hds.push(<th>{i+1}</th>)
    }
    return hds
  }
  const displayPitchCall = (data, len) => {
    let pcs = []
    for (let i=0; i<len; i++) {
      if (i >= data.length || data[i].call==='B') pcs.push(<td></td>)
      else pcs.push(<td>{pitchCallImageMap[data[i].call]}</td>)
    }
    return pcs
  }
  const displayPitchData = (data, len, target) => {
    let output = []
    for (let i=0; i<len; i++) {
      if (i >= data.length) output.push(<td></td>)
      else output.push(<td>{data[i][target]}</td>)
    }
    return output
  }
  const displayWhiteSpace = (len) => {
    let wts = []
    for (let i=0; i<len; i++) wts.push(<td className='white'></td>)
    return wts
  }
  const tableLen = Math.max(data.length, 10)
  return (
    <table className='eachhitter_table'>
      <tbody>
        <tr>
          {displayHeader(tableLen)}
        </tr>
        <tr>
          {displayPitchCall(data, tableLen)}
        </tr>
        <tr>
          {displayPitchData(data, tableLen, 'tag')}
        </tr>
        <tr>
          {displayWhiteSpace(tableLen)}
        </tr>
        <tr>
          {displayPitchData(data, tableLen, 'speed')}
        </tr>
      </tbody>
    </table>
  )
}
const displayOuts = (outs) => {
  const outMap = [['ball_out','ball_out'], ['ball_outr', 'ball_out'], ['ball_outr', 'ball_outr']]
  return (
    <>
      <span className={outMap[outs][0]} />
      <span className={outMap[outs][1]} />
    </>
  )
}
const displayResult = (result) => {
  return (
    <div className='eachhitter_res'>
      <div className='eachhitter_res_entry'>
        <p className='eachhitter_res_title'>擊球初速：</p>
        <p className='eachhitter_res_value'>{result.ev}</p>
      </div>
      <div className='eachhitter_res_entry'>
        <p className='eachhitter_res_title'>擊球仰角：</p>
        <p className='eachhitter_res_value'>{result.la}</p>
      </div> 
      <div className='eachhitter_res_entry'>
        <p className='eachhitter_res_title'>打席結果：</p>
        <p className='eachhitter_res_value'>{result.result}</p>
      </div>         
    </div>
  )
}
const SinglePlayFrame = ({playData}) => {
  return (
    <div className='eachhitter_frame'>
      <div className='eachhitter_block'>
        <div className='eachhitter_pitcher'>
          <div className='eachhitter_pitcher_title'>投手：{`${playData.pitcher} ${playData.pitcherSide}`}</div>
          <KZoneChart chartdata={playData.zoneGraphData} />
        </div>
      </div>
      <div className='eachhitter_block2'>
        <div className='eachhitter_info'>
          <span className='date'>{playData.date}</span>
          {/*<span className='status'></span>*/}
          <span className='out'>出局數：{displayOuts(playData.outs)}</span>
        </div>
        <div className='eachhitter_pbp_res'>
          <PlayByPitchTable data={playData.pbp} />
          {displayResult(playData.playResult)}
        </div>
      </div>
      <div className='eachhitter_block'>
        <div className='eachhitter_hitter'>
          <div className='eachhitter_hitter_title'>打者：{`${playData.batter} ${playData.batterSide}`}</div>
          <FieldChart chartdata={playData.fieldGraphData} />
          {/*<div className='eachhitter_hitter_tip'>打席結果：{playData.playResult.result}</div>*/}
        </div>
      </div>
    </div>
  )
}

const PlayByPlayFrame = ({data}) => {
  //console.log(data, data!==undefined)
  const displayPlays = (data) => {
    return data.map((e) => {
      return <SinglePlayFrame playData={e} />
    })
  }
  return (
    <div className='page_content tab_table'>
      <div className='page_tab_frame2'>
        <div className='tab_block tab_selected'>
          <div className='tab'>逐球逐打席數據</div>
        </div>
      </div>
      <div className='tab_content tab_content_gray'>
        {data===undefined? "No Data Available":displayPlays(data)}
      </div>
    </div>
  )
}

export const PersonFrame = ({type, data, graphData, global, plays, prGraph}) => {
  //console.log(data, graphData, prGraph)
  //console.log(plays)
  const [current, setCurrent] = useState('statistic')
  return (
    <div className='wrap setin'>
      <div className='page_tab_frame'>
        {displayTab(type, current, setCurrent)}
      </div>
      <div className='page'>
        {
          current==='statistic'?
          <PitcherGraphPageFrame data={data} graphData={graphData} global={global} prdata={prGraph} plateLocData={extractPlateLocationData(plays)} /> :
          <PlayByPlayFrame data={plays}/>
        }
      </div>
    </div>
  )
}

export const PersonBatterFrame = ({ type, data, teststatPR, anglePR, volePR, plays }) => {
  //console.log(plays)
  const [current, setCurrent] = useState('statistic')
  return (
    <div className='wrap setin'>
      <div className='page_tab_frame'>
        {displayTab(type, current, setCurrent)}
      </div>
      <div className='page'>
        {
          current==='statistic'?
          (data === undefined ? [] :  <PersonalBatterTable data={data} teststatPR={teststatPR} anglePR={anglePR} volePR={volePR} />):
          <PlayByPlayFrame data={plays}/>
        }
      </div>
    </div>
  )
}